module.exports = __webpack_public_path__ + "static/media/landing-logo.fbceba17.png";